// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primaryDarker":"#361359","outer":"_1IrB"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Messages/ThreadList/ThreadList.scss
// module id = tCme
// module chunks = 0